<template>
  <div
    id="main"
    class="main">
    <MainHead v-if="$route.path !== '/pay' && $route.path !== '/wx-code' && $route.path !== '/home'"/>
    <router-view />
  </div>
</template>

<script>
import MainHead from '../components/Common/MainHead.vue'

export default {
  components: { MainHead }
}
</script>

<style lang="stylus" scoped>
.main
  height 100%
</style>
